import { CommonModule } from "@angular/common";
import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	forwardRef,
	Input,
} from "@angular/core";
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";

/**
 * Área de texto del design-system `.ds`, sin Material. Patrón `.ff-field` con `<textarea>`.
 * `ControlValueAccessor` → `formControlName` / `[(ngModel)]`. Sustituye a
 * `mat-form-field` + `textarea matInput`.
 */
@Component({
	selector: "app-ds-textarea",
	standalone: true,
	imports: [CommonModule, FormsModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => DsTextareaComponent),
			multi: true,
		},
	],
	template: `
		<div class="ff-field">
			<label *ngIf="label">{{ label }}<span class="req" *ngIf="required">*</span></label>
			<div class="ff-box">
				<textarea
					[rows]="rows"
					[placeholder]="placeholder"
					[disabled]="disabled"
					[ngModel]="value"
					(ngModelChange)="onInput($event)"
					(blur)="onTouched()"
				></textarea>
			</div>
			<div class="ff-hint" *ngIf="hint">{{ hint }}</div>
		</div>
	`,
	styles: [":host{display:block}"],
})
export class DsTextareaComponent implements ControlValueAccessor {
	@Input() label = "";
	@Input() hint = "";
	@Input() placeholder = "";
	@Input() required = false;
	@Input() disabled = false;
	@Input() rows = 3;

	value = "";

	private onChange = (_value: string): void => {
		// intentional
	};
	onTouched = (): void => {
		// intentional
	};

	constructor(private readonly cdr: ChangeDetectorRef) {}

	writeValue(value: string): void {
		this.value = value ?? "";
		this.cdr.markForCheck();
	}

	registerOnChange(fn: (value: string) => void): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
		this.cdr.markForCheck();
	}

	onInput(value: string): void {
		this.value = value ?? "";
		this.onChange(this.value);
	}
}
